export default {
  search: 'Search',
  from: 'From',
  to: 'To'
};
